export type CDMRecord = {
  id: string;
  name: string;
  tenantId: string;
  domain?: string;
  targetSchema?: 'dbo' | 'analytical' | 'snapshot';
  tenantName: string;
  status: string;
  type: string;
  category?: string;
  version: number;
  description: string;
  egressOptions: number[];
  schema: string;
  expression: string;
  cardinality: number;
  environment?: number;
  ingestionType: string;
  ingestionOptions?: IngestionOptions;
  schemaErrorText?:string,
  cdmNameError?: string,
  isEO14117Protected?: boolean;
  primaryKey?: string | null;
  alternateKeys?: string[];
  compositeKey?: string[];
};

export type EntityType = CDMRecord & { properties: string [] | null };

export type IngestionOptions = {
  storageAccountName?: string;
  clientId?: string;
  clientSecretName?: string;
  basePath?: string;
  folderPath?: string;
  fileName?: string;
  fileType?: string;
  idProperty?: string;
  handshakeType?: string;
  defaultHandshakeFilePath?: string;
  handshakeDescription?: string;
  ingressFrequency?: string;
  // How this entity type enters the Fabric medallion: Pull, Shortcut or Push.
  // Absent means it is still served by Synapse bulk ingestion.
  ingestionMethod?: string;
};

export const IngestionMethod = {
  Pull: 'Pull',
  Push: 'Push',
  Shortcut: 'Shortcut',
} as const;

export const ingestionMethodDescriptions: Record<string, string> = {
  [IngestionMethod.Pull]: 'HRDP pulls the data from your storage based on the ingestion frequency.',
  [IngestionMethod.Push]: 'You are granted access to write the data directly to the HRDP lakehouse.',
  [IngestionMethod.Shortcut]: 'HRDP creates a shortcut from your data store to the HRDP bronze lakehouse.',
};

// Bulk entity types default to Pull when no ingestion method has been chosen yet.
// Note: setting a method moves the entity type's bulk ingestion from Synapse to Fabric once approved.
export const withDefaultIngestionMethod = (cdm: CDMRecord): CDMRecord => {
  if (cdm?.ingestionType !== 'Bulk' || cdm.ingestionOptions?.ingestionMethod) {
    return cdm;
  }
  return {
    ...cdm,
    ingestionOptions: { ...cdm.ingestionOptions, ingestionMethod: IngestionMethod.Pull },
  };
};
